// extracted by mini-css-extract-plugin
export default {"gridSection":"MuiKpiPaper_gridSection__EADsa","printGridBlock":"MuiKpiPaper_printGridBlock__nej96","topSectionTitle":"MuiKpiPaper_topSectionTitle__RkA6L"};